<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Buat Parts Quotation Baru</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-xs-12 col-md-6">
                      <div class="input-group">
                        <label class="label">Sparepart<span style="color: red;">*</span></label>
                        <!-- {{available_estimations}} -->
                        <MultiSelect
                          v-model="form.estimations_id"
                          :options="available_estimations.map(x => x.id)"
                          :custom-label="opt => available_estimations.find(x => x.id == opt).name + ' - ' + available_estimations.find(x => x.id == opt).part_description"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Sparepart"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Supplier<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.supplier_id"
                          :options="options.supplier.map(x => x.id)"
                          :custom-label="opt => options.supplier.find(x => x.id == opt).name"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Pilih Supplier"
                        ></MultiSelect>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-12">
                      <div class="input-group">
                        <label class="label">Waktu Inden (Hari)<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.inden" placeholder="Ketik Waktu Inden">
                      </div>
                    </div>
                    
                  </div>
				  <div class="row row-space">
						<div class="col-xs-12 col-md-6">
							<div class="input-group">
								<label class="label">Harga Pricelist Supplier<span style="color: red;">*</span></label>
								<input class="input--style-4" type="text" name="name" v-model="form.supplier_pricelist" placeholder="Ketik Harga Pricelist Supplier">
							</div>
						</div>
						<div class="col-xs-12 col-md-6">
							<div class="input-group">
								<label class="label">Diskon Supplier<span style="color: red;">*</span></label>
								<input class="input--style-4" type="text" name="name" v-model="form.supplier_discount" placeholder="Ketik Diskon Supplier">
							</div>
						</div>
                  </div>
                  <div class="row row-space">
                    
                    <div class="col-xs-12">
                      <div class="input-group">
                        <label class="label">Harga Satuan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.price_per_item" placeholder="Ketik Harga Satuan">
                      </div>
                        <div class="form-check form-check-inline col-12">
                          <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="form.without_ppn">
                          <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                        </div>
                        <div class="form-check form-check-inline col-12">
                          <input class="form-check-input" :disabled="form.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="form.ppn_included">
                          <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                        </div>
                    </div>
                    
                    
                  </div>
                  
                  
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Buat</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import MultiSelect from 'vue-multiselect';

  export default {
    data () {
      return {
        options : {
          supplier : this.$store.getters.getSupplier
        },
        rangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        form : {
          estimations_id : '',
          supplier_id : '',
          price_per_item : '',
          inden : '',
          ppn_included : false,
          markup : 0,
          supplier_discount : '',
          supplier_pricelist : '',
          without_ppn  : false
        }
      }
    },
    props : ['available_estimations', 'form_code'],
    components:{
      MultiSelect,
    },
    mounted () {

    },
    watch : {
      'form.price_per_item' : function () {
        let total = 0
        if(this.form.price_per_item.includes('%')) {
          let discount = parseFloat(this.form.price_per_item.split('%')[0]) / 100
          total = Math.round(parseInt(this.form.supplier_pricelist.split(',').join('')) * (1 - discount))
        }
        else {
          total = this.form.price_per_item
        }
          
        const result = total.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.form.price_per_item = result);
	  },
	  'form.supplier_pricelist' : function () {
        const result = this.form.supplier_pricelist.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.form.supplier_pricelist = result);
      }
    },
    methods : {
      validateForm(form){
        var valid = true;
        var error = [];
        form.price_per_item = parseFloat(form.price_per_item.split(',').join(''))

        if(form.estimations_id == '' || form.estimations_id == null){//Sparepart [Required]
          valid = false;
          error.push('Sparepart wajib diisi');
        }

        if(form.supplier_id == '' || form.supplier_id == null){//Supplier [Required]
          valid = false;
          error.push('Supplier wajib diisi');
        }

        if(form.price_per_item == '' || form.price_per_item == null){//Harga Satuan [Required]
          valid = false;
          error.push('Harga Satuan wajib diisi');
        } else if (isNaN(form.price_per_item)) {
          valid = false;
          error.push('Harga Satuan harus berbentuk nomor');
        }

        if(form.inden == '' || form.inden == null){//Harga Satuan [Required]
          valid = false;
          error.push('Inden wajib diisi');
        } else if (isNaN(form.inden)) {
          valid = false;
          error.push('Inden harus berbentuk nomor');
        }

        if(form.supplier_discount == '' || form.supplier_discount == null){//Harga Satuan [Required]
          valid = false;
          error.push('Diskon Supplier wajib diisi');
        }

        if(form.supplier_pricelist == '' || form.supplier_pricelist == null){//Harga Satuan [Required]
          valid = false;
          error.push('Pricelist Supplier wajib diisi');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(){
        let vm = this;
        let form = JSON.parse(JSON.stringify(this.form))
        if(vm.validateForm(form)){

          //Convert from string to float
          // form.price_per_item = parseFloat(this.form.price_per_item)
          form.inden = parseInt(form.inden)
          form.markup = parseFloat(form.markup)

          this.$http.post(`/api/v1/estimations-supplier/`, form)
          .then((resp)=>{
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$store.dispatch('triggerAlert', [true, [`Estimasi supplier telah berhasil ditambahkan`]]);
            this.$emit('updateTable');
            this.$emit('closeModal');
          })
          .catch((err)=>{
            console.log(err);
            this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
          })
        }
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}
</style>
